import { useEffect, useState } from 'react'

const MOBILE_BREAKPOINT = 768
const TABLET_BREAKPOINT = 1024

const isMobileScreen = (): boolean =>
    typeof window !== 'undefined'
        ? window.innerWidth < MOBILE_BREAKPOINT
        : false

const isTabletScreen = (): boolean =>
    typeof window !== 'undefined'
        ? window.innerWidth < TABLET_BREAKPOINT
        : false

/**
 * SSR-safe mobile detection. Returns false on server and first client render,
 * then the real viewport match after mount. Use instead of isMobileScreen() in components.
 */
const useIsMobileScreen = (breakpoint = MOBILE_BREAKPOINT): boolean => {
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const update = () => setIsMobile(window.innerWidth < breakpoint)
        update()
        window.addEventListener('resize', update)
        return () => window.removeEventListener('resize', update)
    }, [breakpoint])

    return isMobile
}

const useIsTabletScreen = (breakpoint = TABLET_BREAKPOINT): boolean => {
    const [isTablet, setIsTablet] = useState(false)

    useEffect(() => {
        const update = () => setIsTablet(window.innerWidth < breakpoint)
        update()
        window.addEventListener('resize', update)
        return () => window.removeEventListener('resize', update)
    }, [breakpoint])

    return isTablet
}

export { isMobileScreen, isTabletScreen, useIsMobileScreen, useIsTabletScreen }
